<template>
  <div class="">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">Score Setting</h1>
      <div class="d-flex justify-content-end align-items-center">
        <p class="mr-2">Qualification Score :</p>
        <InputNumber
          textFloat=""
          placeholder="Score"
          class="w-30"
          v-model="qualificationScore"
          :isValidate="$v.qualificationScore.$error"
          :v="$v.qualificationScore"
          :disabled="isBusy"
        />
        <p class="ml-2">{{ $t("point") }}</p>
      </div>
    </div>
    <div class="bg-white-border p-3 text-black main-theme">
      <b-table
        responsive
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(score)="data">
          <div class="input-score-wrapper">
            <InputNumber
              textFloat=""
              placeholder="Score"
              :name="data.item.name"
              v-model="data.item.score"
              class="w-20"
              :isValidate="$v.items.$each[data.index].score.$error"
              :v="$v.items.$each[data.index].score"
            />
          </div>
        </template>
        <template v-slot:cell(isActive)="data">
          <toggle-button
            class="mt-1 mr-1"
            v-model="data.item.isActive"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
          />
        </template>
      </b-table>
      <b-row>
        <b-col cols="6" class="text-sm-left">
          <p class="p-2 text-error">{{ $t("note") }} : {{ $t("noteScore") }}</p>
        </b-col>
        <b-col cols="6" class="text-sm-right">
          <button
            type="button"
            @click="handleSubmit()"
            :disabled="isBusy"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import InputNumber from "@/components/inputs/InputNumber";
import { required, integer, minValue } from "vuelidate/lib/validators";

export default {
  name: "SettingScoreIndex",
  components: { InputNumber },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Condition",
        },
        {
          key: "score",
          label: "Score",
        },
        {
          key: "isActive",
          label: "Status",
        },
      ],
      items: [],
      isBusy: false,
      qualificationScore: 0,
    };
  },
  validations: {
    items: {
      $each: {
        score: {
          required,
          integer,
          minValue: minValue(0),
        },
      },
    },
    qualificationScore: {
      required,
      integer,
      minValue: minValue(0),
    },
  },
  async created() {
    await this.handleInitData();
  },
  computed: {
    totalScore() {
      let total = 0;
      this.items.forEach((item) => {
        if (item.isActive) {
          total += Number(item.score);
        }
      });
      return total;
    },
  },
  methods: {
    async handleInitData() {
      this.isBusy = true;
      await this.getSettingScore();
      await this.getQualificationScore();
      this.isBusy = false;
    },
    async getQualificationScore() {
      const response = await this.axios.get(
        `${this.$baseUrl}/ScoreSetting/QualificationScore`
      );
      if (response && response.result === 1) {
        const { qualificationScore } = response.detail;
        this.qualificationScore = qualificationScore;
      }
    },
    async getSettingScore() {
      const response = await this.axios.get(`${this.$baseUrl}/ScoreSetting`);
      if (response && response.result === 1) {
        this.items = response.detail;
      }
    },
    async handleSubmit() {
      this.$v.items.$touch();
      this.$v.qualificationScore.$touch();
      if (this.$v.items.$error || this.$v.qualificationScore.$error) {
        return;
      }
      if (this.totalScore !== 100) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: "Total score must be 100.",
        });
        return;
      }
      const payload = {
        qualificationScore: this.qualificationScore,
        scoreSettings: this.items,
      };

      const response = await this.axios.put(`${this.$baseUrl}/ScoreSetting`, {
        ...payload,
      });

      if (response) {
        if (response.result === 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: response.message,
          });
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: response.message,
          });
        }
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: "Something went wrong. Please try again.",
        });
      }
      await this.handleInitData();
    },
  },
};
</script>

<style lang="scss" scoped>
.input-score-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
